import React from 'react';
import { render } from 'react-dom';
import Login from '../src/components/login/Login';
//import App from './App';
import Header from './components/header/Header';
import Menu from './components/menu/Menu';
import Footer from './components/footer/Footer';
import Layout from './components/layout/Layout';
import Tournaments from './components/tournament/Tournaments';
import Captains from './components/captains/Captains';
import BreadCrumb from './components/breadcrumb/BreadCrumb';
import { ToastContainer } from "react-toastify";
// import registerServiceWorker from './registerServiceWorker';
import './index.css';
import 'bulma/css/bulma.css';
import 'bulma/css/bulma-switch.min.css';
import './assets/css/fontawesome-all.css';

// ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();


import { BrowserRouter, Route } from 'react-router-dom'
import Leagues from "./components/league/League";
import Teams from "./components/team/Teams";
import Players from "./components/player/Players";
import Referees from "./components/referee/Referees";
import Courts from "./components/court/Courts";
import Matches from "./components/matches/Matches";
import MatchPdf from "./components/matches/MatchPdf";
import MatchResult from "./components/matches/matchResult";
import TeamDetails from "./components/team/Details";
import Punished from './components/punished/Punished';

class App extends React.Component{
    constructor(props){
        super(props);
        this.state = {didLogin: false};
    }
    render() {
        return (
            <BrowserRouter>
                <div className="App">
                    <div className="columns">
                        <Menu/>
                        <div className="column is-10 admin-panel">
                            <Header/>
                            <div className="container padding-top">
                                <BreadCrumb/>
                                <div className="card">

                                    <Route path="/Torneos" component={Tournaments}/>
                                    <Route path="/Ligas" component={Leagues} />
                                    <Route path="/Jugadores" component={Players}/>
                                    <Route path="/Inicio" component={Layout}/>
                                    <Route path="/Arbitros" component={Referees}/>
                                    <Route path="/Canchas" component={Courts}/>
                                    <Route path="/Resultado/juego/:value" component={MatchResult}/>
                                    <Route path="/Juegos" component={Matches}/>
                                    <Route path="/Detalles/equipo/:value" component={TeamDetails} />
                                    <Route path="/Equipos" component={Teams} />
                                    <Route path="/Capitanes" component={Captains} />
                                    <Route path="/Sancionados" component={Punished} />
                                    <Route path="/Match_PDF/:value" component={MatchPdf} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer/>
                    <ToastContainer/>
                </div>
            </BrowserRouter>
        )
    }
}

const AppLogin = () => (
    <div className="App">
        <Login/>
    </div>
)

if(localStorage.getItem("token")){
    render(<App />, document.getElementById('root'));
}else{
    render(<AppLogin/>, document.getElementById('root'));
}



// WEBPACK FOOTER //
// ./src/index.js